
import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Eye, EyeOff } from 'lucide-react';
import { useStatsCardData } from './useStatsCardData';

const CardVisibilityManager: React.FC = () => {
  const { hiddenCards, toggleCardVisibility } = useStatsCardData();
  
  const hasHiddenCards = hiddenCards.length > 0;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button 
          variant="outline" 
          className="mr-2"
          disabled={!hasHiddenCards}
        >
          <Eye className="mr-2 h-4 w-4" />
          Hidden Stats ({hiddenCards.length})
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Hidden Stat Cards</DialogTitle>
        </DialogHeader>
        
        {hasHiddenCards ? (
          <div className="space-y-2 py-4">
            {hiddenCards.map(card => (
              <div key={card.id} className="flex justify-between items-center p-3 border rounded-md">
                <span>{card.title}</span>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={() => toggleCardVisibility(card.id, true)}
                >
                  <Eye className="h-4 w-4 mr-1" />
                  Show
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div className="py-4 text-center text-muted-foreground">
            <EyeOff className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p>No hidden stat cards</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CardVisibilityManager;
